export default "__VITE_ASSET__DEkOVQxs__"